import { render } from "./filesystems.vue?vue&type=template&id=9260e4a6&scoped=true"
import script from "./filesystems.vue?vue&type=script&lang=js"
export * from "./filesystems.vue?vue&type=script&lang=js"

import "./filesystems.vue?vue&type=style&index=0&id=9260e4a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9260e4a6"]])

export default __exports__